class MapStylesControl {
  constructor({
    className = "",
    layerIdsToPreserve = [],
    imagesToPreserve = []
  }) {
    this._className = className;
    this._styles = [
      {
        label: "streets",
        value: "streets-v11"
      },
      {
        label: "light",
        value: "light-v10"
      },
      {
        label: "dark",
        value: "dark-v10"
      },
      {
        label: "outdoors",
        value: "outdoors-v11"
      },
      {
        label: "satellite",
        value: "satellite-v9"
      },
      {
        label: "streets satellite",
        value: "satellite-streets-v9"
      }
    ];
    this._layerIdsToPreserve = [...layerIdsToPreserve];
    this._imagesToPreserve = [...imagesToPreserve];
  }

  updateLayerIdsToPreserve(layerIdsToPreserve) {
    this._layerIdsToPreserve = layerIdsToPreserve;
  }

  updateImagesToPreserve(imagesToPreserve) {
    this._imagesToPreserve = imagesToPreserve;
  }

  onAdd(map) {
    // eslint-disable-next-line
    const me = this;
    const select = document.createElement("select");
    select.addEventListener("change", e => {
      function forEachLayer(text, cb) {
        map.getStyle().layers.forEach(layer => {
          if (!layer.id.includes(text)) return;

          cb(layer);
        });
      }

      const savedLayers = [];
      const savedSources = {};
      const savedImages = [];

      me._layerIdsToPreserve.forEach(layerToKeep => {
        forEachLayer(layerToKeep, layer => {
          savedSources[layer.source] = map.getSource(layer.source).serialize();
          savedLayers.push(layer);
        });
      });

      me._imagesToPreserve.forEach(imageToKeep => {
        savedImages.push(imageToKeep);
      });

      map.setStyle(`mapbox://styles/mapbox/${e.target.value}`);

      setTimeout(() => {
        Object.entries(savedSources).forEach(([id, source]) => {
          map.addSource(id, source);
        });

        savedLayers.forEach(layer => {
          map.addLayer(layer);
        });

        savedImages.forEach(image => {
          map.loadImage(image.url, function (error, i) {
            if (error) return;
            map.addImage(image.id, i);
          });
        });

        setTimeout(() => {
          map.triggerRepaint();
        }, 400);
      }, 400);
    });
    select.className = this._className;
    for (let i = 0; i < this._styles.length; i++) {
      const style = this._styles[i];
      const option = document.createElement("option");
      option.setAttribute("id", style.value);
      option.setAttribute("value", style.value);

      // select this option it's the style that has been selected
      if (style.value === map.getStyle().metadata["mapbox:origin"]) {
        option.setAttribute("selected", "selected");
      }

      option.text = style.label;
      select.add(option);
    }

    const container = document.createElement("div");
    container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
    container.appendChild(select);

    this._container = container;
    this._map = map;
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}

export default MapStylesControl;
